module.exports = __webpack_public_path__ + "static/Product-Summary-P3.91-Transparent-Indoor-Led-1d242f8e44fa3ae0fd30a8eb9b335b72.jpg";